import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import { NavLink } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  recoNotification: {
    position: 'absolute',
    right: '-5px',
    top: '-5px',
    backgroundColor: props => `rgb(${props.configColors['--color_33']})`,
    borderRadius: '50%',
    color: props => `rgb(${props.configColors['--color_54']})`,
    height: '22px',
    width: '22px',
    fontSize: '.8rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: '.5s',
  },
  topNavLink: {
    color: props => `rgb(${props.configColors['--color_4']})`,
    margin: '0 10px',
    padding: '8px 20px',
    lineHeight: '22px',
    verticalAlign: 'middle',
    display: 'flex',
    borderRadius: 3,
    position: 'relative',
    '&:hover': {
      backgroundColor: props => `rgb(${props.configColors['--color_1']})`,
      color: props => `rgb(${props.configColors['--color_54']})`
    }
  },
  topNavLinkActive: {
      backgroundColor: props => `rgb(${props.configColors['--color_1']})`,
      color: props => `rgb(${props.configColors['--color_54']})`
  }
}));

export default function BCLStyledNavLink(props) {

  const classes = useStyles(props);

  return (
      <NavLink to={props.to} activeClassName={classes.topNavLinkActive} className={classes.topNavLink} style={{ textDecoration: 'none' }}>
        <span className={props.icon} />
        {props.name}
        {props.translationData && props.name === props.translationData["TOP_MENU_ITEMS.MY_RECOMMENDATIONS"] && props.unviewedRecos > 0 && (
          <span className={classes.recoNotification}>
            {props.unviewedRecos}
          </span>
        )}
      </NavLink>
  );
}
